import React, { Suspense, lazy } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"
import { graphql, useStaticQuery } from "gatsby"

import Link from "./Link"
import SearchSVG from "../images/icons/search-large.inline.svg"

const SearchOverlay = lazy(() => import("./SearchOverlay"))

const SearchIcon = styled.div`
  display: flex;

  a {
    color: inherit;

    > span {
      display: flex;
    }
  }

  svg {
    display: block;
    height: auto;
    width: 20px;
  }

  @media print {
    display: none;
  }
`

const SearchButton = styled.span`
  align-items: center;
  display: flex;
`

const SearchLabel = styled.span`
  display: inline-block;
  margin: 0 0 0 5px;
`

const HeaderSearch = ({ className, mode, label }) => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query SearchHeaderQuery {
      localSearchResultsEn {
        publicIndexURL
        publicStoreURL
      }
      localSearchResultsDe {
        publicIndexURL
        publicStoreURL
      }
    }
  `)

  const { publicIndexURL, publicStoreURL } =
    data[
      `localSearchResults${
        intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)
      }`
    ] || data.localSearchResultsEn

  return (
    <SearchIcon className={className}>
      {mode === "link" ? (
        <Link
          to={`/${intl.locale}/search/`}
          title={intl.formatMessage({ id: "header.shortlinks.search" })}
          intl={false}
        >
          <SearchSVG aria-hidden="true" />
          {label ? (
            <SearchLabel className="search-label">{label}</SearchLabel>
          ) : null}
        </Link>
      ) : null}
      {mode === "overlay" ? (
        <Suspense
          fallback={
            <Link
              to={`/${intl.locale}/search/`}
              title={intl.formatMessage({ id: "header.shortlinks.search" })}
              intl={false}
            >
              <SearchSVG aria-hidden="true" />
              {label ? (
                <SearchLabel className="search-label">{label}</SearchLabel>
              ) : null}
            </Link>
          }
        >
          <SearchOverlay
            indexUrl={publicIndexURL}
            storeUrl={publicStoreURL}
            button={
              <SearchButton>
                <SearchSVG aria-hidden="true" />
                {label ? (
                  <SearchLabel className="search-label">{label}</SearchLabel>
                ) : null}
              </SearchButton>
            }
          />
        </Suspense>
      ) : null}
    </SearchIcon>
  )
}

HeaderSearch.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.string.isRequired,
}

export default HeaderSearch
